exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/views/pages/transaction/op/outbound/ticket/ticket-confirmation/ticket-confirmation.component.css
// module id = 792
// module chunks = 7